"use strict";
exports.__esModule = true;
var react_1 = require("react");
var GoogleStreetViewContext = react_1.createContext({
    map: null,
    setMap: null,
    mapState: null,
    setMapState: null
});
exports.GoogleStreetViewContext = GoogleStreetViewContext;
